import React from 'react';
import { useNavigate } from 'react-router-dom';

const PerformanceComparison = ({ results, quiz }) => {
  const navigate = useNavigate();
  
  if (!results?.quiz_statistics) {
    return null;
  }

  const isHigher = results.score >= results.quiz_statistics.average_score;
  const difference = Math.round(results.score - results.quiz_statistics.average_score);
  const hasMultipleAttempts = quiz?.total_attempts > 1;
  const bestScore = quiz?.best_score !== null && quiz?.best_score !== undefined 
    ? Math.round(quiz.best_score) : null;

  return (
    <div className="col-lg-4">
      <div className="quiz-card h-100">
        <div className="quiz-card-header">
          <h6 className="quiz-subtitle-modern">Quick Summary</h6>
        </div>
        <div className="quiz-card-body">
          <div className="d-flex flex-column h-100 justify-content-between">
            
            {/* Simplified Progress Section */}
            <div className="progress-section mb-3">
              {bestScore !== null && hasMultipleAttempts && (
                <div className="stat-row">
                  <span className="stat-label">🏆 Your Best</span>
                  <span className="stat-value text-warning">{bestScore}%</span>
                </div>
              )}
              
              <div className="stat-row">
                <span className="stat-label">Global Stand</span>
                <span className={`stat-value ${isHigher ? 'text-success' : 'text-danger'}`}>
                  {isHigher ? '↑' : '↓'} {isHigher ? '+' : ''}{difference}%
                </span>
              </div>
              
              {hasMultipleAttempts && (
                <div className="stat-row">
                  <span className="stat-label">Total Attempts</span>
                  <span className="stat-value text-info">{quiz.total_attempts}</span>
                </div>
              )}
            </div>
            
            {/* View Analysis Button */}
            <div className="text-center mt-auto">
              <button 
                className="btn-modern btn-outline-primary btn-sm w-100"
                onClick={() => navigate(`/quiz-history/${quiz.quiz_id}`)}
                style={{ fontSize: '0.85rem', padding: '6px 12px' }}
              >
                <i className="bi bi-graph-up"></i> View Analysis
              </button>
            </div>
            
            {results.quiz_statistics.total_attempts > 1 && (
              <div className="mt-2">
                <small className="text-muted d-block text-center">
                  {results.quiz_statistics.total_attempts} global attempts
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceComparison;
